import { useLang } from "../i18n/LanguageContext";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_DISPLAY, waLink } from "../constants/images";
import { SectionHead, Reveal } from "./Reveal";
import { Phone, MessageCircle, MapPin } from "lucide-react";

const ContactSection = () => {
  const { t } = useLang();

  return (
    <section id="kontakt" className="relative bg-[#0D0F12] py-20 sm:py-28 overflow-hidden" data-testid="contact-section">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(ellipse 60% 45% at 50% 100%, rgba(217,107,39,0.18), transparent)" }}
      />
      <div className="grain" />

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8">
        <SectionHead eyebrow={t.contact.eyebrow} title={t.contact.title} subtitle={t.contact.subtitle} dark />

        <div className="mt-12 grid md:grid-cols-2 gap-5">
          <Reveal delay={0.1}>
            <a
              data-testid="contact-call-card"
              href={PHONE_TEL}
              className="group flex flex-col h-full bg-[#14181D] border border-white/12 hover:border-[#D96B27] p-7 sm:p-9 transition-all duration-300 hover:-translate-y-1.5"
            >
              <span className="w-12 h-12 flex items-center justify-center bg-[#D96B27] text-[#0D0F12]">
                <Phone className="w-5 h-5" />
              </span>
              <p className="mt-6 font-mono2 text-xs uppercase tracking-[0.3em] text-[#94A3B8]">{t.contact.callTitle}</p>
              <p className="mt-2 font-display font-extrabold text-2xl sm:text-3xl text-[#F4F1EA] tracking-tight" dir="ltr" style={{ textAlign: "start" }}>
                {PHONE_DISPLAY}
              </p>
              <p className="mt-3 text-sm text-[#94A3B8] leading-relaxed">{t.contact.callDesc}</p>
            </a>
          </Reveal>

          <Reveal delay={0.2}>
            <a
              data-testid="contact-whatsapp-card"
              href={waLink(t.contact.waMessage)}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col h-full bg-[#14181D] border border-white/12 hover:border-[#25D366] p-7 sm:p-9 transition-all duration-300 hover:-translate-y-1.5"
            >
              <span className="w-12 h-12 flex items-center justify-center bg-[#25D366] text-[#0D0F12]">
                <MessageCircle className="w-5 h-5" />
              </span>
              <p className="mt-6 font-mono2 text-xs uppercase tracking-[0.3em] text-[#94A3B8]">{t.contact.whatsappTitle}</p>
              <p className="mt-2 font-display font-extrabold text-2xl sm:text-3xl text-[#F4F1EA] tracking-tight" dir="ltr" style={{ textAlign: "start" }}>
                {WHATSAPP_DISPLAY}
              </p>
              <p className="mt-3 text-sm text-[#94A3B8] leading-relaxed">{t.contact.whatsappDesc}</p>
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.25}>
          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/10 pt-6">
            <p className="flex items-start gap-2.5 text-sm text-[#F4F1EA]/75 max-w-2xl leading-relaxed">
              <MapPin className="w-4 h-4 text-[#D96B27] shrink-0 mt-1" />
              {t.contact.regionLabel}
            </p>
            <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#94A3B8]" dir="ltr">
              43.8563° N — 18.4131° E · SARAJEVO
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ContactSection;
